export default "__VITE_ASSET__6bbf3954__"